import React, { useState } from "react";

import { Box, Button, LinearProgress, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { CloudUpload } from "@mui/icons-material";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const GetLocalFile = ({ label, onUploaded }) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    onUploaded(file);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
    >
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUpload />}
      >
        {label ? label : "Upload File"}
        <VisuallyHiddenInput
          type="file"
          onChange={handleFileChange}
          multiple
        />
      </Button>
      {/* <input
        type="file"
        onChange={handleFileChange}
      /> */}
      {file && (
        <Box>
          <Typography>{`Filename: ${file.name}`}</Typography>
          <Typography>{`Size: ${(file.size / 1024).toFixed(2)} KB`}</Typography>
          <Typography>{`Type: ${file.type}`}</Typography>
        </Box>
      )}
      {file && (
        <Button
          size="small"
          variant="contained"
          onClick={handleUpload}
        >
          Process
        </Button>
      )}
    </Box>
  );
};

export default GetLocalFile;
